module.exports = __webpack_public_path__ + "images/bg-gray.png";


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/_images/bg-gray.png
// module id = 911
// module chunks = 0